/* eslint-disable react/no-danger */
'use client';

import Script from 'next/script';
import React, { useEffect, useState } from 'react';

const DialogflowChat: React.FC = () => {
	const [mounted, setMounted] = useState(false);

	// Only run on client-side
	useEffect(() => {
		setMounted(true);
	}, []);

	// Don't render anything on the server
	if (!mounted) {
		return null;
	}

	return (
		<>
			<Script
				id="dialogflow-css"
				strategy="afterInteractive"
				src="https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/themes/df-messenger-default.css"
				rel="stylesheet"
			/>
			<Script
				id="dialogflow-js"
				strategy="afterInteractive"
				src="https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js"
			/>
			<div
				suppressHydrationWarning
				dangerouslySetInnerHTML={{
					__html: `
<df-messenger
  project-id="cometforge-454416"
  agent-id="b12f147e-c7ff-43e5-b0ea-4a6dd2367d0f"
  language-code="en"
  max-query-length="-1">
  <df-messenger-chat-bubble
    chat-title="Cometforge Chat">
  </df-messenger-chat-bubble>
</df-messenger>
<style>
  df-messenger {
    z-index: 999;
    position: fixed;
    --df-messenger-font-color: #000;
    --df-messenger-font-family: Google Sans;
    --df-messenger-chat-background: #f3f6fc;
    --df-messenger-message-user-background: #d3e3fd;
    --df-messenger-message-bot-background: #fff;
    bottom: 16px;
    right: 16px;
  }
</style>
        `,
				}}
			/>
		</>
	);
};

export default DialogflowChat;
